import React from 'react'
import { ElectricalChargingStationIcon } from 'src/Libs/flow/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { localizeEmobilityNumber } from '../utils/localize-emobility-number'
import { Card } from './Card'

interface Props {
  energyKWh: number
}

export const TotalGridEnergyCard: React.FC<Props> = ({ energyKWh }) => {
  const { t } = useCustomTranslation()

  const positiveEnergyKWh = Math.max(0, energyKWh)

  return (
    <Card
      Icon={ElectricalChargingStationIcon}
      label={t('emobility.chargingSession.totalGridEnergyCharged')}
      value={t('common.format.kwh', '', {
        value: localizeEmobilityNumber(positiveEnergyKWh),
      })}
    />
  )
}
